import { InternHeadline } from '../intern/headline';
import { InternIcon } from '../intern/icon';
import { InternText } from '../intern/text';
import { ContentIntro } from './intro';

/**
 * Model definition for Comparision Table
 */
export interface ContentComparisonTable {
  __component: 'content.comparison-table';
  id: string;
  intro?: ContentIntro;
  advantagesHeadline?: InternHeadline;
  advantagesButtonText?: string;
  advantages: InternText[];
  advantagesIcon?: InternIcon;
  disadvantagesHeadline?: InternHeadline;
  disadvantagesButtonText?: string;
  disadvantages: InternText[];
  disadvantagesIcon?: InternIcon;
}

export function isContentComparisonTable(obj: { __component?: string }): obj is ContentComparisonTable {
  return obj.__component === 'content.comparison-table';
}
